import { UpgradeAssessment, UpgradeStage } from 'api/models';

export const UPGRADE_ASSESSMENT_GKE_131: UpgradeAssessment = {
  id: 'upgrasses_c4aa47e1-f865-46d4-8b2d-3a15165e6392',
  name: 'assessment-gke-131-usw4-sandbox-1.31-1.32',
  status: 'ready',
  deployment_strategy: 'in-place',
  environment: 'Sandbox',
  current_version: '1.31',
  desired_version: '1.32',
  resources: { clusters: [{ id: 'id-gke-131-usw4-sandbox' }] },
  requested_by: {
    id: 'usr_w12123',
    name: 'Katy Smith',
    picture: '',
  },
  created: new Date(2025, 11, 9).getTime(), // December 9, 2025
  header: {
    items: [
      {
        title: 'Cluster Name (Chkk)',
        value: 'gke-131-usw4-sandbox',
      },
      {
        title: 'Current',
        value: '1.31',
      },
      {
        title: 'Recommended',
        value: '1.32',
      },
      {
        title: 'Provider',
        value: 'GKE',
      },
      {
        title: 'Region',
        value: 'us-west4',
      },
      {
        title: 'Node Groups',
        value: '7',
      },
      {
        title: 'Nodes',
        value: '46',
      },
      {
        title: 'Blueprint',
        value: 'In-Place',
      },
      {
        title: 'Projects',
        value: '25',
      },
    ],
  },
  exports: [
    {
      format: 'pdf',
      url: '/assessment-gke-131.pdf',
    },
    {
      format: 'markdown',
      url: '/assessment-gke-131.md',
    },
  ],
};

export const UPGRADE_ASSESSMENT_GKE_131_STAGES: UpgradeStage[] = [
  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Control Plane \u0026 Application Changes',
    stage_number: 1,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'K8s',
              },
              {
                title: 'Current',
              },
              {
                title: 'Recommended',
              },
            ],
            data: [
              [
                {
                  value: 'Control Plane',
                },
                {
                  value: '1.31',
                },
                {
                  value: '1.32',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Infrastructure Changes',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Namespace',
              },
              {
                title: 'Kind',
              },
              {
                info_text: 'The API currently used by the resource',
                title: 'Current Version',
              },
              {
                info_text:
                  'The K8s version which stopped serving the currently used API',
                title: 'Removed In',
              },
              {
                info_text:
                  'The APIs offered as a recommended replacement to the currently used API',
                title: 'Recommended Versions',
              },
            ],
            data: [
              [
                {
                  value: 'payments-api-04',
                },
                {
                  value: 'default',
                },
                {
                  value: 'FlowSchema',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1beta3',
                },
                {
                  value: '1.32',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1',
                },
              ],
              [
                {
                  value: 'login-gateway-secure-02',
                },
                {
                  value: 'default',
                },
                {
                  value: 'FlowSchema',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1beta3',
                },
                {
                  value: '1.32',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1',
                },
              ],
              [
                {
                  value: 'platform-dev-backend-09',
                },
                {
                  value: 'default',
                },
                {
                  value: 'FlowSchema',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1beta3',
                },
                {
                  value: '1.32',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1',
                },
              ],
              [
                {
                  value: 'comments-middleware-01',
                },
                {
                  value: 'default',
                },
                {
                  value: 'FlowSchema',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1beta3',
                },
                {
                  value: '1.32',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Deprecations \u0026 Removals',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Application',
              },
              {
                title: 'Namespace',
              },
              {
                title: 'Resource',
              },
              {
                title: 'Current Allowed Disruptions',
              },
            ],
            data: [
              [
                {
                  value: 'payments-api-04',
                },
                {
                  value: 'media',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'platform-dev-backend-02',
                },
                {
                  value: 'auth',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'platform-dev-backend-01',
                },
                {
                  value: 'auth',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Misconfigured Pod Disruption Budgets (PDBs)',
        owner: 'chkk',
        status: 'active',
        step_number: 3,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },
  {
    allowed_action_types: [],
    created: 1765462811650,
    icon: 'FeatherChevronDown',
    name: 'Project Changes',
    stage_number: 2,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Namespace(s)',
              },
              {
                title: 'Current',
              },
              {
                title: 'Upgrade',
              },
              {
                info_text:
                  'Suggested versions do not go through Preverification. Request an Upgrade Templates for Preverified Version Recommendations. Learn more: https://docs.chkk.io/features/upgrade-preverification#upgrade-preverification',
                title: 'Suggested',
              },
              {
                info_text:
                  'Will the current remain compatible with the next Kubernetes version after the cluster is upgraded?',
                title: 'K8s Compatibility',
              },
              {
                info_text:
                  'Is the current version supported by its upstream community, cloud or vendor?',
                title: 'Supported',
              },
              {
                info_text: 'Is the current version younger than 2 years?',
                title: 'Age \u003c 2yr',
              },
              {
                info_text:
                  'Use the feedback buttons to indicate whether you agree or disagree with this upgrade suggestion.',
                render_in: {
                  cli: false,
                  markdown: false,
                  web: true,
                },
                title: 'Give Feedback',
              },
              {
                render_in: {
                  cli: false,
                  markdown: false,
                  web: true,
                },
                title: 'Actions',
              },
            ],
            data: [
              [
                {
                  value: 'ArgoCD',
                },
                {
                  value: 'argocd',
                },
                {
                  value: '2.11.3',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '3.2.1',
                },
                {
                  icon: {
                    tooltip:
                      'Argo CD’s tested matrix does not list support for Kubernetes 1.32, so 2.11.3 is considered incompatible.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      '2.11.3 is end-of-life under Argo CD’s N-2 support policy.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_30e39ed1-5e82-4806-af53-92866f4b25e0',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'External Secrets Operator',
                },
                {
                  value: 'external-secrets',
                },
                {
                  value: '0.10.0',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '1.1.0',
                },
                {
                  icon: {
                    tooltip:
                      'The vendor’s compatibility matrix shows this version is not guaranteed to work on Kubernetes 1.32.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      '0.10.0 is outside the vendor’s supported minor range and is therefore end-of-life.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_0f9f596d-9bf6-40ed-b95e-a21ab4d3dd58',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Linkerd OSS',
                },
                {
                  value: 'linkerd',
                },
                {
                  value: 'stable-2.14.10',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: 'edge-25.12.1',
                },
                {
                  icon: {
                    tooltip:
                      '2.14.10 is not listed as compatible with Kubernetes 1.32 in the Linkerd compatibility matrix.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_37552aaf-74ae-4e1e-9c5b-442c6542b8fd',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Redis OSS',
                },
                {
                  value: 'example-ns-2',
                },
                {
                  value: '7.4.1',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '8.4.0',
                },
                {
                  icon: {
                    tooltip:
                      'Redis 7.4.1 is not listed as compatible with GKE 1.32 according to Redis’ Kubernetes compatibility matrix.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_1cb203e4-497c-4842-98f1-337e2a2ec051',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Redis OSS',
                },
                {
                  value: 'akuity',
                },
                {
                  value: '7.2.11',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '8.4.0',
                },
                {
                  icon: {
                    tooltip:
                      'Redis 7.2.11 is marked incompatible with GKE Kubernetes 1.32.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_1cb203e4-497c-4842-98f1-337e2a2ec051',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Redis OSS',
                },
                {
                  value: 'argocd',
                },
                {
                  value: '7.2.4-alpine',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '8.4.0',
                },
                {
                  icon: {
                    tooltip:
                      '7.2.4 is not validated for Kubernetes 1.32 on GKE per the vendor’s compatibility table.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_1cb203e4-497c-4842-98f1-337e2a2ec051',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Apache Kafka',
                },
                {
                  value: 'kafka',
                },
                {
                  value: '3.6.1-debian-11-r0',
                },
                {
                  badges: [
                    {
                      text: 'Optional',
                      variant: 'neutral',
                    },
                  ],
                  value: '',
                },
                {
                  value: '3.7.0',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      'Version 3.6.1 is no longer within Kafka’s N-3 support window, so it no longer receives fixes.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_86818caf-b906-47c3-9ad0-e442a01b4b0f',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Datadog Agent',
                },
                {
                  value: 'datadog',
                },
                {
                  value: '7.71.1',
                },
                {
                  badges: [
                    {
                      text: 'Optional',
                      variant: 'neutral',
                    },
                  ],
                  value: '',
                },
                {
                  value: '7.72.4',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      '7.71.1 is no longer within Datadog’s supported window.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_5888c383-2d4e-4fe4-ab83-292587895e2b',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Ingress NGINX Controller (Community)',
                },
                {
                  value: 'ingress-nginx',
                },
                {
                  value: '1.12.1',
                },
                {
                  badges: [
                    {
                      text: 'Optional',
                      variant: 'neutral',
                    },
                  ],
                  value: '',
                },
                {
                  value: 'controller-v1.14.0',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      'controller-v1.12.1 is no longer supported by the project.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_5b72ff12-b76a-46fe-b7c6-e6a8f5982c51',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Prometheus',
                },
                {
                  value: 'linkerd-viz',
                },
                {
                  value: '2.48.0',
                },
                {
                  badges: [
                    {
                      text: 'Optional',
                      variant: 'neutral',
                    },
                  ],
                  value: '',
                },
                {
                  value: '3.8.0',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      '2.48.0 has reached end-of-life according to Prometheus’ published release-cycle policy.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip: '2.48.0 was released more than 24 months ago.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_7f1e198a-c2e0-446b-8567-f7154dfb38de',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Prometheus JMX Exporter',
                },
                {
                  value: 'kafka',
                },
                {
                  value: '0.20.0-debian-11-r1',
                },
                {
                  badges: [
                    {
                      text: 'Optional',
                      variant: 'neutral',
                    },
                  ],
                  value: '',
                },
                {
                  value: '1.5.0',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      '0.20.0 was published in August 2023, so it is older than the 24-month freshness window.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_b4f52709-129e-41b6-a7c5-c552759baba8',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Upbound Crossplane (UXP)',
                },
                {
                  value: 'upbound-system',
                },
                {
                  value: '1.13.2-up.3',
                },
                {
                  badges: [
                    {
                      text: 'Optional',
                      variant: 'neutral',
                    },
                  ],
                  value: '',
                },
                {
                  value: '1.20.1-up.1',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      'Upbound supports only the current and two previous minors; 1.13 is outside that window and no longer maintained.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip: 'The installed release is over two years old.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_7fbc38b5-e211-428a-85ba-43337e8be9eb',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765462811650,
        icon: 'FeatherChevronRight',
        name: 'Projects Marked for Upgrade',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765462811650,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Current Version',
              },
              {
                title: 'Namespaces',
              },
              {
                title: 'Reasons',
              },
              {
                info_text:
                  'Use the feedback buttons to indicate whether you agree or disagree with this upgrade suggestion.',
                title: 'Give Feedback',
              },
            ],
            data: [
              [
                {
                  value: 'cert-manager',
                },
                {
                  value: '1.18.1',
                },
                {
                  value: 'cert-manager',
                },
                {
                  value:
                    'Project documentation states 1.18.x works with Kubernetes 1.32. 1.18.1 remains inside the project’s N,N-1 support window and is not end-of-life. Released less than two years ago, so it is not outdated.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Dex',
                },
                {
                  value: '2.38.0',
                },
                {
                  value: 'argocd',
                },
                {
                  value:
                    'Dex requires Kubernetes 1.14 or newer; version 1.32 meets this requirement, so the addon is compatible. Dex does not publish a support policy, so end-of-life status cannot be confirmed. The release was published less than 24 months ago, so it is still considered current.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'ExternalDNS',
                },
                {
                  value: '0.15.1-debian-12-r6',
                },
                {
                  value: 'external-dns',
                },
                {
                  value:
                    'Project documentation lists v0.15.x as compatible with Kubernetes 1.32, so no incompatibility is expected. ExternalDNS does not publish formal support timelines, so end-of-life status for v0.15.1 cannot be determined. The release is less than 24 months old, so it is not considered outdated.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GCP Cloud SQL Auth Proxy',
                },
                {
                  value: '2',
                },
                {
                  value: 'example-ns-2',
                },
                {
                  value:
                    'No incompatibility with Kubernetes 1.32 found, but data about this specific build is incomplete. This release is past the one-year support period stated in the project’s policy. Release date unknown, so age could not be verified.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GCP Cloud SQL Auth Proxy',
                },
                {
                  value: 'latest',
                },
                {
                  value: 'cep',
                },
                {
                  value:
                    'The running release tag is not a fixed version, so Kubernetes compatibility cannot be verified. The running release tag is not a fixed version, so support status cannot be verified. The running release tag is not a fixed version, so its age cannot be determined.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Google CAS Issuer for cert-manager',
                },
                {
                  value: '0.10.0',
                },
                {
                  value: 'cert-manager',
                },
                {
                  value:
                    'No known issues between this release and Kubernetes 1.32 were found in Chkk Knowledge Graph. Chkk Knowledge Graph does not list this release as end-of-life. Release date information is missing, so age could not be verified as more than two years.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Keycloak',
                },
                {
                  value: '20251103.14.0.4',
                },
                {
                  value: 'platform-keycloak',
                },
                {
                  value:
                    'Compatibility with Kubernetes 1.32.0 cannot be verified as this internal build is not tracked in the Chkk Knowledge Graph. Unable to confirm support status because the current build is internal and not mapped to any upstream release. Release date is unknown, so we cannot determine whether it is older than 24 months.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Stakater Reloader',
                },
                {
                  value: '1.0.114',
                },
                {
                  value: 'default',
                },
                {
                  value:
                    'The installed version officially supports Kubernetes 1.32. The project does not publish an end-of-life policy, so this release cannot be considered EOL. This release is less than 24 months old.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765462811650,
        icon: 'FeatherChevronRight',
        name: 'Projects Not Changing',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765462811650,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Namespace(s)',
              },
              {
                title: 'Current',
              },
              {
                info_text:
                  'Use the feedback buttons to indicate whether you agree or disagree with this upgrade suggestion.',
                render_in: {
                  cli: false,
                  markdown: false,
                  web: true,
                },
                title: 'Give Feedback',
              },
            ],
            data: [
              [
                {
                  value: 'Antrea',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.4.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Google Compute Engine Persistent Disk CSI Driver',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.14.6',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Kube Proxy',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.31.13-gke.1040000',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Cilium',
                },
                {
                  value: 'cilium',
                },
                {
                  value: '1.15.6-gke1.31-gke.60',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Cluster Proportional Autoscaler',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.9.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Cluster Proportional Autoscaler',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.9.1',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Cluster Proportional Autoscaler',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.8.11',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'CSI node-driver-registrar',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '2.10.1',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'CSI node-driver-registrar',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '2.9.4',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Fluent Bit',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.8.1200',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Fluent Bit GKE Exporter',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.27.9',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GCP Filestore CSI Driver',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.8.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GCP GCS FUSE CSI Driver',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.8.9',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GCP Prometheus Engine',
                },
                {
                  value: 'gke-gmp-system',
                },
                {
                  value: '2.45.3',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Event Exporter',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.5.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Agent',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.13.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20250605_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20240902_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'gke-managed-cim',
                },
                {
                  value: '20240501_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20240909_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20250915_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20240508_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20250724_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20240424_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20241015_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE Metrics Collector',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '20240717_2300_RC0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'GKE TPU Device Plugin',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.31.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'IP Masquerade Agent',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '2.11.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'KAS Network Proxy',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.31.3',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'kube-state-metrics',
                },
                {
                  value: 'gke-managed-cim',
                },
                {
                  value: '2.7.0-gke.82',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Kubernetes DNS',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.23.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Kubernetes Metrics Server',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.7.1',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Metadata Proxy',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.1.12',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'netd',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.9.8',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'NodeLocal DNS Cache',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.23.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'NVIDIA device plugin for Kubernetes',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.31.0',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'prometheus-to-sd',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.11.12',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'prometheus-to-sd',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.12.1',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'prometheus-to-sd',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '0.11.1',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765462811650,
        icon: 'FeatherChevronRight',
        name: 'Projects Managed by Provider',
        owner: 'chkk',
        status: 'active',
        step_number: 3,
        updated: 1765462811650,
      },
    ],
    updated: 1765462811650,
  },
  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Breaking Changes \u0026 Advisories',
    stage_number: 3,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get Upgrade Advisories for every component (worker nodes, OS, Add-ons, Projects) on your upgrade path.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Upgrade Advisories',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get all the changes that require your attention during the upgrade.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Breaking Changes',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },
  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Helm, CRD, RBAC Changes',
    stage_number: 4,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get side-by-side diffs of current vs. target CustomResourceDefinitions and Custom Resources, including schema updates.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'CRD Diff',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get exact additions and removals in ClusterRoles, Roles, and Bindings introduced by the upgrade.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'RBAC Changes',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get full diffs of Helm chart values, template files, Kustomize overlays, and raw manifests.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Package Changes for Helm, Kustomize, Raw Manifests',
        owner: 'chkk',
        status: 'active',
        step_number: 3,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },
  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Preflight/Postflight Checks',
    stage_number: 5,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get automated and guided preflight checks run before the upgrade to verify health and rollback safety for every Add-on version, Application Service version, control plane and nodes.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Preflight Checks',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get automated and guided postflight checks run after the upgrade to verify health and rollback safety for every Add-on version, Application Service version, control plane and nodes.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Postflight Checks',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },
];
